// import React from "react";
// import {
//   Dialog,
//   DialogTitle,
//   DialogContent,
//   DialogActions,
//   IconButton,
//   MenuItem,
//   TextField,
//   Button,
//   Typography,
//   Grid,
//   Box,
//   FormControlLabel,
//   Checkbox
// } from "@mui/material";
// import CloseIcon from "@mui/icons-material/Close";

// const SubscriptionForm = ({ 
//   open, 
//   onClose, 
//   currentItem,
//   onSubmit,
//   userId // Assuming you'll pass the user_id from parent
// }) => {
//   const [formData, setFormData] = React.useState(
//     currentItem || {
//       plan_name: "",
//       // plan_type: "Limited",
//       user_type: "",
//       charges: "",
//       buyer_no_unlimited: false,
//       no_of_properties_unlimited: false,
//       no_of_liked_data_unlimited: false,
//       matching_enquiry_unlimited: false,
//        buyer_no: 0,
//       no_of_properties: 0,
//       no_of_liked_data: 0,
//       matching_enquiry: 0
//     }
//   );

//   const handleChange = (e) => {
//     const { name, value, type, checked } = e.target;
//     setFormData(prev => ({
//       ...prev,
//       [name]: type === 'checkbox' ? checked : value
//     }));
//   };

//   const handleSubmit = () => {
//     // Convert numeric fields to numbers
//     const payload = {
//       user_id: userId, // This should be passed from parent component
//       ...formData,
//       charges: Number(formData.charges),
//       buyer_no: formData.buyer_no_unlimited ? null : Number(formData.buyer_no),
//       no_of_properties: formData.no_of_properties_unlimited ? null : Number(formData.no_of_properties),
//       no_of_liked_data: formData.no_of_liked_data_unlimited ? null : Number(formData.no_of_liked_data),
//       matching_enquiry: formData.matching_enquiry_unlimited ? null : Number(formData.matching_enquiry)
//     };
    
//     onSubmit(payload);
//     onClose();
//   };

//   return (
//     <Dialog 
//       open={open} 
//       onClose={onClose} 
//       maxWidth="sm" 
//       fullWidth
//     >
//       <DialogTitle>
//         <Typography variant="h6">
//           {currentItem ? 'Edit Subscription Plan' : 'Add New Subscription Plan'}
//         </Typography>
//         <IconButton
//           aria-label="close"
//           onClick={onClose}
//           sx={{
//             position: "absolute",
//             right: 8,
//             top: 8,
//             color: (theme) => theme.palette.grey[500],
//           }}
//         >
//           <CloseIcon />
//         </IconButton>
//       </DialogTitle>
      
//       <DialogContent dividers>
//         <Grid container spacing={3}>
//           <Grid item xs={12} md={6}>

//               <TextField
//               margin="normal"
//               fullWidth
//               select
//               label="User Type"
//               name="user_type"
//               value={formData.user_type}
//               onChange={handleChange}
//               required
//             >
//               <MenuItem value="Buyer">Buyer</MenuItem>
//               <MenuItem value="Tenant">Tenant</MenuItem>
//               <MenuItem value="Seller/Builder">Seller/Builder</MenuItem>
//               <MenuItem value="Landlord">Landlord</MenuItem>
//               {/* <MenuItem value="Builder">Builder</MenuItem> */}
//               <MenuItem value="Agent">Agent</MenuItem>
//             </TextField>

//             <TextField
//               margin="normal"
//               fullWidth
//               select
//               label="Plan Name"
//               name="plan_name"
//               value={formData.plan_name}
//               onChange={handleChange}
//               required
//             >
//               <MenuItem value="Free">Free</MenuItem>
//               <MenuItem value="1 Months">1 Month</MenuItem>
//               <MenuItem value="3 Months">3 Months</MenuItem>
//               <MenuItem value="6 Months">6 Months</MenuItem>
//               <MenuItem value="12 Months">12 Months</MenuItem>
//               <MenuItem value="Lifetime">Lifetime</MenuItem>
//             </TextField>
            
            
//             <TextField
//               margin="normal"
//               fullWidth
//               label="Price (Charges)"
//               name="charges"
//               type="number"
//               value={formData.charges}
//               onChange={handleChange}
//               required
//               inputProps={{ min: 0 }}
//             />
            
//             <FormControlLabel
//               control={
//                 <Checkbox
//                   checked={formData.buyer_no_unlimited}
//                   onChange={handleChange}
//                   name="buyer_no_unlimited"
//                   color="primary"
//                 />
//               }
//               label="Unlimited Buyer Access"
//             />
            
//             {!formData.buyer_no_unlimited && (
//               <TextField
//                 margin="normal"
//                 fullWidth
//                 type="number"
//                 label="Buyer Limit"
//                 name="buyer_no"
//                 value={formData.buyer_no}
//                 onChange={handleChange}
//                 inputProps={{ min: 0 }}
//               />
//             )}
//           </Grid>

//           <Grid item xs={12} md={6}>
//             <FormControlLabel
//               control={
//                 <Checkbox
//                   checked={formData.no_of_properties_unlimited}
//                   onChange={handleChange}
//                   name="no_of_properties_unlimited"
//                   color="primary"
//                 />
//               }
//               label="Unlimited Properties"
//             />
            
//             {!formData.no_of_properties_unlimited && (
//               <TextField
//                 margin="normal"
//                 fullWidth
//                 type="number"
//                 label="Property Limit"
//                 name="no_of_properties"
//                 value={formData.no_of_properties}
//                 onChange={handleChange}
//                 inputProps={{ min: 0 }}
//               />
//             )}
            
//             <FormControlLabel
//               control={
//                 <Checkbox
//                   checked={formData.no_of_liked_data_unlimited}
//                   onChange={handleChange}
//                   name="no_of_liked_data_unlimited"
//                   color="primary"
//                 />
//               }
//               label="Unlimited Liked Data"
//             />
            
//             {!formData.no_of_liked_data_unlimited && (
//               <TextField
//                 margin="normal"
//                 fullWidth
//                 type="number"
//                 label="Liked Data Limit"
//                 name="no_of_liked_data"
//                 value={formData.no_of_liked_data}
//                 onChange={handleChange}
//                 inputProps={{ min: 0 }}
//               />
//             )}
            
//             <FormControlLabel
//               control={
//                 <Checkbox
//                   checked={formData.matching_enquiry_unlimited}
//                   onChange={handleChange}
//                   name="matching_enquiry_unlimited"
//                   color="primary"
//                 />
//               }
//               label="Unlimited Matching Enquiries"
//             />
            
//             {!formData.matching_enquiry_unlimited && (
//               <TextField
//                 margin="normal"
//                 fullWidth
//                 type="number"
//                 label="Matching Enquiry Limit"
//                 name="matching_enquiry"
//                 value={formData.matching_enquiry}
//                 onChange={handleChange}
//                 inputProps={{ min: 0 }}
//               />
//             )}
//           </Grid>
//         </Grid>
//       </DialogContent>
      
//       <DialogActions>
//         <Button onClick={onClose} color="secondary">
//           Cancel
//         </Button>
//         <Button onClick={handleSubmit} color="primary" variant="contained">
//           {currentItem ? 'Update' : 'Create'}
//         </Button>
//       </DialogActions>
//     </Dialog>
//   );
// };

// export default SubscriptionForm;

import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  IconButton,
  MenuItem,
  TextField,
  Button,
  Typography,
  Grid,
  Box,
  FormControlLabel,
  Checkbox
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

const SubscriptionForm = ({ 
  open, 
  onClose, 
  currentItem,
  onSubmit,
  userId
}) => {
  const [formData, setFormData] = React.useState(
    {
      plan_name: "",
      user_type: "",
      charges: "",
      actual_price: "",
      buyer_no_unlimited: false,
      no_of_properties_unlimited: false,
      no_of_liked_data_unlimited: false,
      matching_enquiry_unlimited: false,
      buyer_no: 0,
      no_of_properties: 0,
      no_of_liked_data: 0,
      matching_enquiry: 0,
    trial_days: null
    }
  );

   React.useEffect(() => {
    if (currentItem) {
      setFormData({
        plan_name: currentItem.plan_name || "",
        user_type: currentItem.user_type || "",
        charges: currentItem.charges || "",
        actual_price: currentItem.actual_price || "",
        buyer_no_unlimited: currentItem.buyer_no_unlimited || false,
        no_of_properties_unlimited: currentItem.no_of_properties_unlimited || false,
        no_of_liked_data_unlimited: currentItem.no_of_liked_data_unlimited || false,
        matching_enquiry_unlimited: currentItem.matching_enquiry_unlimited || false,
        buyer_no: currentItem.buyer_no || 0,
        no_of_properties: currentItem.no_of_properties || 0,
        no_of_liked_data: currentItem.no_of_liked_data || 0,
        matching_enquiry: currentItem.matching_enquiry || 0,
          trial_days: currentItem.trial_days || null
      });
    } else {
      // Reset to default for new items
      setFormData({
        plan_name: "",
        user_type: "",
        charges: "",
        actual_price: "",
        buyer_no_unlimited: false,
        no_of_properties_unlimited: false,
        no_of_liked_data_unlimited: false,
        matching_enquiry_unlimited: false,
        buyer_no: 0,
        no_of_properties: 0,
        no_of_liked_data: 0,
        matching_enquiry: 0,
        trial_days: null
      });
    }
  }, [currentItem, open]);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value
    }));
  };

  const handleSubmit = () => {
    const payload = {
      user_id: userId,
      ...formData,
      charges: Number(formData.charges),
      actual_price: Number(formData.actual_price),
      buyer_no: formData.buyer_no_unlimited ? null : Number(formData.buyer_no),
      no_of_properties: formData.no_of_properties_unlimited ? null : Number(formData.no_of_properties),
      no_of_liked_data: formData.no_of_liked_data_unlimited ? null : Number(formData.no_of_liked_data),
      matching_enquiry: formData.matching_enquiry_unlimited ? null : Number(formData.matching_enquiry),
        trial_days: formData.plan_name === "Free" ? Number(formData.trial_days) : null
    };
    
    onSubmit(payload);
    onClose();
  };

  // Determine which fields to show based on user type
  const isBuyerOrTenant = formData.user_type === "Buyer" || formData.user_type === "Tenant";
  const isSellerOrBuilder = formData.user_type === "Individual Owner/Builder" || formData.user_type === "Landlord";
  const isAgent = formData.user_type === "Agent";
   const isFreePlan = formData.plan_name === "Free";

  return (
    <Dialog 
      open={open} 
      onClose={onClose} 
      maxWidth="sm" 
      fullWidth
    >
      <DialogTitle>
        <Typography variant="h6">
          {currentItem ? 'Edit Subscription Plan' : 'Add New Subscription Plan'}
        </Typography>
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      
      <DialogContent dividers>
        <Grid container spacing={3}>
          <Grid item xs={12} md={6}>
            <TextField
              margin="normal"
              fullWidth
              select
              label="User Type"
              name="user_type"
              value={formData.user_type}
              onChange={handleChange}
              required
            >
              <MenuItem value="Buyer">Buyer</MenuItem>
              <MenuItem value="Tenant">Tenant</MenuItem>
              <MenuItem value="Individual Owner/Builder">Individual Owner/Builder</MenuItem>
              <MenuItem value="Landlord">Landlord</MenuItem>
              <MenuItem value="Agent">Agent</MenuItem>
            </TextField>

            <TextField
              margin="normal"
              fullWidth
              select
              label="Plan Name"
              name="plan_name"
              value={formData.plan_name}
              onChange={handleChange}
              required
            >
              <MenuItem value="Free">Free</MenuItem>
              <MenuItem value="1 Months">1 Month</MenuItem>
              <MenuItem value="3 Months">3 Months</MenuItem>
              <MenuItem value="6 Months">6 Months</MenuItem>
              <MenuItem value="12 Months">12 Months</MenuItem>
              <MenuItem value="Lifetime">Lifetime</MenuItem>
            </TextField>

             {isFreePlan && (
              <TextField
                margin="normal"
                fullWidth
                label="Trial Days"
                name="trial_days"
                type="number"
                value={formData.trial_days || ""}
                onChange={handleChange}
                required
                inputProps={{ min: 1 }}
              />
            )}
            
            <TextField
              margin="normal"
              fullWidth
              label="Price (Charges)"
              name="charges"
              type="number"
              value={formData.charges}
              onChange={handleChange}
              required
              inputProps={{ min: 0 }}
            />
             <TextField
              margin="normal"
              fullWidth
              label="Actual Price (Charges)"
              name="actual_price"
              type="number"
              value={formData.actual_price}
              onChange={handleChange}
              required
              inputProps={{ min: 0 }}
            />
          </Grid>

          <Grid item xs={12} md={6}>
            {/* Fields for Buyer/Tenant */}
           {(isBuyerOrTenant || isAgent || isSellerOrBuilder) && (
  <>
    <FormControlLabel
      control={
        <Checkbox
          checked={formData.no_of_properties_unlimited}
          onChange={handleChange}
          name="no_of_properties_unlimited"
          color="primary"
        />
      }
      label={
        isBuyerOrTenant 
          ? "Unlimited Access to Owner Details" 
          : "Unlimited Uploading Properties"
      }
    />
    
    {!formData.no_of_properties_unlimited && (
      <TextField
        margin="normal"
        fullWidth
        type="number"
        label={
          isBuyerOrTenant 
            ? "Owner Details Access Limit" 
            : "Uploading Property Limit"
        }
        name="no_of_properties"
        value={formData.no_of_properties}
        onChange={handleChange}
        inputProps={{ min: 0 }}
      />
    )}
  </>
)}

            {/* Fields for Seller/Builder/Landlord */}
            {(isSellerOrBuilder || isAgent) && (
              <>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={formData.no_of_liked_data_unlimited}
                      onChange={handleChange}
                      name="no_of_liked_data_unlimited"
                      color="primary"
                    />
                  }
                  label="Unlimited Wishlist Data"
                />
                
                {!formData.no_of_liked_data_unlimited && (
                  <TextField
                    margin="normal"
                    fullWidth
                    type="number"
                    label="Wishlist Data Limit"
                    name="no_of_liked_data"
                    value={formData.no_of_liked_data}
                    onChange={handleChange}
                    inputProps={{ min: 0 }}
                  />
                )}
                  <FormControlLabel
                  control={
                    <Checkbox
                      checked={formData.matching_enquiry_unlimited}
                      onChange={handleChange}
                      name="matching_enquiry_unlimited"
                      color="primary"
                    />
                  }
                  label="Unlimited Matching Buyers"
                />
                
                {!formData.matching_enquiry_unlimited && (
                  <TextField
                    margin="normal"
                    fullWidth
                    type="number"
                    label="Matching Buyers Limit"
                    name="matching_enquiry"
                    value={formData.matching_enquiry}
                    onChange={handleChange}
                    inputProps={{ min: 0 }}
                  />
                )}
              </>
            )}
          </Grid>
        </Grid>
      </DialogContent>
      
      <DialogActions>
        <Button onClick={onClose} color="secondary">
          Cancel
        </Button>
        <Button onClick={handleSubmit} color="primary" variant="contained">
          {currentItem ? 'Update' : 'Create'}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default SubscriptionForm;